import React from 'react';

class Header extends React.Component {
  render() {
    return (
      <div>
          Header
      </div>
    );
  }
}

export default Header;
